import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminNav from '../AdminNav/AdminNav';
import styles from './AdminLayout.module.scss';
import { IoMenu } from 'react-icons/io5';

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  return (
    <div className={styles.adminLayout}>
      <button className={styles.hamburgerButton} onClick={toggleSidebar}>
        <IoMenu />
      </button>
      <AdminNav 
        isSidebarOpen={isSidebarOpen} 
        closeSidebar={() => setIsSidebarOpen(false)} 
      />
      {isSidebarOpen && (
        <div 
          className={styles.overlay} 
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}
      <div className={styles.adminContent}>
        <Outlet /> 
      </div>
    </div>
  );
};

export default AdminLayout;